import { DefaultSelection36RfiReviewerPayload, IPRFIReviewSubmitItem } from "../api-generated";
import TimeStampWithDraft from "./timeStampWithDraft";

export default class RFIReview
  extends TimeStampWithDraft
  implements IPRFIReviewSubmitItem
{
  public Guid: string;

  public Response: string;

  public hasComments: boolean;

  constructor(rfiReview: DefaultSelection36RfiReviewerPayload) {
    super(rfiReview);

    this.Guid = rfiReview.Guid;

    this.Response = rfiReview.Response ?? "";

    this.hasComments = true;
  }
}
